export default __webpack_public_path__ + "static/media/videocall2.a1970dfe.svg";